var _rect, _rect2, _rect3, _rect4, _rect5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210mm",
    height: "150mm",
    viewBox: "0 0 210 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 98.701,
    width: 50,
    height: 45
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 53.701,
    width: 50,
    height: 45,
    style: {
      mixBlendMode: "darken",
      paintOrder: "normal"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 98.701,
    width: 35,
    height: 45
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 53.701,
    width: 35,
    height: 45
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 98.701,
    width: 70,
    height: 45
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 53.701,
    width: 70.001,
    height: 45
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m29.788 53.957 70.425-12.421v12.421h-70.425",
    strokeLinecap: "square",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.98 53.68h-84.96v-34.958l84.96 34.958",
    style: {
      mixBlendMode: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.5 128.7h15v-22.5h-15v22.5",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.5 83.701h15v-22.5h-15v22.5",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110 83.701h15v-22.5h-15v22.5",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 83.701h37.5v-22.5h-37.5v22.5",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 128.7h37.5v-22.5h-37.5v22.5",
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m110.05 143.65h14.891v-32.446h-14.891v32.446",
    strokeLinecap: "square",
    strokeWidth: 1.0443,
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.98293 -.18396 0 1 0 0)",
    x: 17.804,
    y: 53.732,
    width: 83.943,
    height: 6.1129,
    strokeLinecap: "round",
    strokeWidth: 1.0086,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.92621 .37701 .013623 .99991 0 0)",
    x: 95.603,
    y: -29.845,
    width: 117.38,
    height: 7.6921,
    strokeLinecap: "round",
    strokeWidth: 1.042,
    style: {
      paintOrder: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.5 61.201v22.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.5 61.212v22.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 106.19v22.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70 106.2v22.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo_header.02756d026a62148b8b8e8bc61cc3221a.svg";
export { ForwardRef as ReactComponent };